// surveySlice.js
export const createSurveySlice = (set, get) => ({
  // Survey metadata with all settings support
  survey: {
    id: null,
    templateType: 'template', //template || clinicsurvey  
    title: 'Untitled Survey',
    description: '', 
    category: '',
    createdAt: null,
    updatedAt: null,
    status: 'draft', // draft, active, paused, completed, archived
    slug: null, //only for clinicsurvey
    showProgressbar: false,
    progressbarType: 'percent', //Percentage,Number of Questions, (new)
    singleQuestionPerPage: false, //(new)
    templateId: null, //only for clinicsurvey. null if created blank
    modifiedTemplate: false,
    startDate: null, //only for clinicsurvey
    endDate: null, //only for clinicsurvey
    surveyEndMessage: 'This survey has ended. We appreciate your time and support.',
    targetResponse: null, //clinicsurvey
    maxResponse: null, //clinicsurvey
    allowAnonymous: false,
    redirectUrl: null, //clinicsurvey
    messageAfterComplete: null, 
    redirectTimeAfterMessage: 0, // in seconds 
    customCss: null,
    additionalSettings: null,
    pageWidth: '900px', //added new
    pagePaddingDesktop: '2rem',
    formContainerShowCard: false,
    formContainerCardShadow: false,
    formContainerPadding: '2rem',
    formContainerBackgroundColor: 'auto', // auto uses surface color
    formContainerBorderRadius: 'auto', // auto uses theme border radius
    headerPosition:"center",
    headingType:"h1",
    descriptionPosition: "center",
    descriptionColor:"",
    icon:"journal-bookmark",
    iconColor:"info" //primary,warning,success,danger,info
  },

  // Actions for survey metadata and settings
  updateSurveyMetadata: (metadata) =>
    set((state) => ({
      survey: { ...state.survey, ...metadata, updatedAt: new Date().toISOString() },
      isDirty: true,
    })),

  // Add or update survey settings dynamically
  updateSurveySettings: (settings) =>
    set((state) => ({
      survey: { ...state.survey, ...settings, updatedAt: new Date().toISOString() },
      isDirty: true,
    })),

  // Add a single survey setting
  setSurveySetting: (key, value) =>
    set((state) => ({
      survey: { ...state.survey, [key]: value, updatedAt: new Date().toISOString() },
      isDirty: true,
    })),

  // Remove a survey setting
  removeSurveySetting: (key) =>
    set((state) => {
      const { [key]: removed, ...remainingSurvey } = state.survey;
      return {
        survey: { ...remainingSurvey, updatedAt: new Date().toISOString() },
        isDirty: true,
      };
    }),

  // Get a specific survey setting
  getSurveySetting: (key, defaultValue = null) => {
    const state = get();
    return state.survey[key] !== undefined ? state.survey[key] : defaultValue;
  },

  // Check if a survey setting exists
  hasSurveySetting: (key) => {
    const state = get();
    return state.survey.hasOwnProperty(key);
  },


});